import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { AppConfig } from './../../app.config';
import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-reference-time-controller',
    templateUrl: './reference-time-controller.component.html',
    styleUrls: ['./reference-time-controller.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ReferenceTimeControllerComponent implements OnInit, AfterViewInit {
    boundaryTimes: moment.Moment[] = [];
    selectedBoundaryTime: moment.Moment;

    constructor(private appConfig: AppConfig, private dashboardEventService: DashboardEventService) {

    }

    ngOnInit() {
        const startHour = this.appConfig.activeUserProfile.getUserStartTimeHour();
        const endHour = this.appConfig.activeUserProfile.getUserEndTimeHour();
        let datetime = moment().startOf('day').add(startHour, 'hours');
        while (datetime.hour() <= endHour) {
            this.boundaryTimes.push(datetime);
            datetime = datetime.clone().add(30, 'minutes');
        }
        // Add EOD
        const eod = this.appConfig.getStartOfDayDatetimeUTC().clone();
        this.boundaryTimes.unshift(eod);
    }

    ngAfterViewInit(): void {
        this.dashboardEventService.explainTimeShiftSubject.next(this.selectedBoundaryTime);
        setTimeout(() => {
            this.selectedBoundaryTime = this.boundaryTimes[0];
        });
    }

    moveToTime(boundaryTime: moment.Moment) {
        this.selectedBoundaryTime = boundaryTime;
        this.dashboardEventService.explainTimeShiftSubject.next(boundaryTime.clone().utc());
    }

}

